import React, { useEffect, useState } from "react"
import RedemptionDetails from "./RedemptionDetails ";
import { useSelector } from "react-redux";

const GiftCardRedemptionSection = (productReducer) => {
  const [isMobile, setIsMobile] = useState(false);
  // to get data from redux store
  const clientInfo = useSelector((state) => state.clientDataReducer);
  // to find rewardWidget is configure or not from client info
  const rewardWidgetConfig = clientInfo?.clientData?.clientConfigurations?.find((config) => config.configKey === "isrewardwidgete");

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };

    handleResize(); // set initial value
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <section className="letshop pdp-denominations-section">
      <div className="container p-0 big-rr mb-2 ">
        <div className="row justify-content-center p-2">
          <div className="col-12 col-lg-12">
            <RedemptionDetails productReducer={productReducer} isMobile={isMobile} />
          </div>
        </div>
      </div>
    </section>
  )

}
export default GiftCardRedemptionSection;
